import jQuery from 'jquery';

/**
 * Expose jQuery globally for GTM tags and third-party scripts (blog prod).
 * Skips assignment when another script already defined window.jQuery.
 */
export function ensureGlobalJQuery(jQueryLib = jQuery) {
    if (typeof window.jQuery === 'undefined') {
        window.jQuery = jQueryLib;
    }
    if (typeof window.$ === 'undefined') {
        window.$ = window.jQuery;
    }
}

/**
 * Runs consent-related third-party bootstrap in a fixed order:
 * jQuery → Axeptio SDK → GTM → consent callbacks.
 */
export function runConsentStackInit({
    ensureJQuery,
    insertAxeptioSdk,
    loadGTM,
    registerConsentCallbacks,
}) {
    ensureJQuery();
    insertAxeptioSdk();
    loadGTM();
    registerConsentCallbacks();
}
